import {configureStore} from "@reduxjs/toolkit";
import createSagaMiddleware from 'redux-saga';
import rootReducer from "./reducer";
import rootSaga from "./saga";
import offlineInvoiceMiddleware from "~/reduxs/Pos/offlineInvoiceMiddleware";

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) => getDefaultMiddleware()
		.concat(sagaMiddleware)
		.concat(offlineInvoiceMiddleware),
});

sagaMiddleware.run(rootSaga);

export default store;